import EnvBase from '@/env'
import svrapi from '@/svrapi'
import { MessageBox } from 'element-ui'
import Cookies from 'js-cookie'
import SparkMD5 from 'spark-md5'
import fs from 'file-saver'
import XLSX from 'xlsx'
import AMapLoader from '@amap/amap-jsapi-loader'

const PT = EnvBase.PT

export function parseTime(time, cFormat, isUTC = false) {
  if (arguments.length === 0) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if (('' + time).length === 10) time = parseInt(time) * 1000
    date = new Date(time)
  }
  let formatObj = null
  if (isUTC) {
    formatObj = {
      y: date.getUTCFullYear(),
      m: date.getUTCMonth() + 1,
      d: date.getUTCDate(),
      h: date.getUTCHours(),
      i: date.getUTCMinutes(),
      s: date.getUTCSeconds(),
      a: date.getUTCDay()
    }
  } else {
    formatObj = {
      y: date.getFullYear(),
      m: date.getMonth() + 1,
      d: date.getDate(),
      h: date.getHours(),
      i: date.getMinutes(),
      s: date.getSeconds(),
      a: date.getDay()
    }
  }
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key]
    if (key === 'a') return ['一', '二', '三', '四', '五', '六', '日'][value - 1]
    if (result.length > 0 && value < 10) {
      value = '0' + value
    }
    return value || 0
  })
  return time_str
}

export function formatTime(time, option) {
  time = +time * 1000
  const d = new Date(time)
  const now = Date.now()

  const diff = (now - d) / 1000

  if (diff < 30) {
    return '刚刚'
  } else if (diff < 3600) { // less 1 hour
    return Math.ceil(diff / 60) + '分钟前'
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前'
  } else if (diff < 3600 * 24 * 2) {
    return '1天前'
  }
  if (option) {
    return parseTime(time, option)
  } else {
    return d.getMonth() + 1 + '月' + d.getDate() + '日' + d.getHours() + '时' + d.getMinutes() + '分'
  }
}

/**
 * 设置路由查询参数
 * @param param {Object} 要设置的参数对象
 * 注意，调用时必须通过call方法或者apply方法调用，否则this指向会报错
 */
export function setRouteQuery(param, method = 'replace') {
  this.$router[method](`${this.$route.path}?${toFormData(param)}`)
}

/**
 * 获取下载地址(新)
 * @param name {string} api名称
 * @param params {object} 参数
 * @param auth {boolean} 是否需要鉴权参数
 * @returns {string} 完整的下载地址
 * 注意，调用时必须通过call方法或者apply方法调用，否则this指向会报错
 */
export function createDownloadUrl(name, params, auth = true) {
  let query = '?'
  if (auth) {
    const token = Cookies.get(PT.qnlogin.localSessName)
    query += `api_local_sess=${token}&api_usagespace=${PT.config.platformUsagespace}&`
  }
  if (Object.keys(params).length) {
    query += `${toFormData(params)}`
  }
  return `${PT.config.apiBaseUrl}${svrapi[name]}${query}`
}

/**
 * 验证表单
 * @param name
 * @returns {Promise<any>}
 * 注意，调用时必须通过call方法或者apply方法调用，否则this指向会报错
 */
export function validate(name) {
  return new Promise((resolve, reject) => {
    this.$refs[name].validate(valid => {
      if (valid) {
        resolve()
      } else {
        reject()
      }
    })
  })
}

/**
 * 重置表单
 * @param name
 * 注意，调用时必须通过call方法或者apply方法调用，否则this指向会报错
 */
export function resetFields(name) {
  this.$refs[name].resetFields()
}

/**
 * 对部分表单字段进行校验的方法
 * @param prop 表单字段
 * 注意，调用时必须通过call方法或者apply方法调用，否则this指向会报错
 */
export function validateField(prop) {
  return new Promise((resolve, reject) => {
    this.$refs[name].validateField(prop, err => {
      if (err) {
        resolve(err)
      } else {
        reject(err)
      }
    })
  })
}

/**
 * 过滤掉空属性
 * @param obj {object} 需要过滤的对象
 * @returns {object}
 */
export function filterEmptyProperty(obj) {
  const params = {}
  Object.keys(obj).forEach(key => {
    if (obj[key] !== null && obj[key] !== undefined && obj[key] !== '') {
      params[key] = obj[key]
    }
  })
  return params
}

/**
 * 代理http请求，返回promise对象
 * @param name {string} api名称
 * @param params {object} api参数
 * @returns Promise
 */
export function agencyQnbarRequest(name, params = {}) {
  return new Promise((resolve, reject) => {
    PT.apiClient.query(svrapi[name], params, (res) => {
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(res)
        if (svrapi[name] !== 'warehouse/agent/psn/check') {
          MessageBox.alert(res.msg, '提示')
        }
      }
    }, (err) => {
      reject({ code: -1, msg: '网络请求失败: ' + err })
    })
  })
}

/**
 * 将参数对象转化为键值对的字符串
 * @param data {object} 参数对象
 * @returns {string}
 */
export function toFormData(data) {
  let res = ''
  Object.keys(data).forEach(key => {
    res += encodeURIComponent(key) + '=' + encodeURIComponent(data[key]) + '&'
  })
  return res.slice(0, -1)
}

/**
 * 深克隆数据
 * @param data {object} 参数对象
 * @returns {Object}
 */
export function deepCopy(data = {}) {
  return JSON.parse(JSON.stringify(data))
}

// MD5解析
export function calculateMd5ByChunkSize(file, chunkSize) {
  return new Promise(resolve => {
    const fileReader = new FileReader()
    const blobSlice = File.prototype.mozSlice || File.prototype.webkitSlice || File.prototype.slice
    const chunks = Math.ceil(file.size / chunkSize)
    let currentChunk = 0
    const spark = new SparkMD5()

    // 读取完成时触发事件
    fileReader.onload = function(e) {
      spark.appendBinary(e.target.result) // append binary string
      currentChunk++
      if (currentChunk < chunks) {
        loadNext()
      } else {
        resolve(spark.end())
      }
    }

    function loadNext() {
      const start = currentChunk * chunkSize,
        end = start + chunkSize >= file.size ? file.size : start + chunkSize
      fileReader.readAsBinaryString(blobSlice.call(file, start, end))
    }

    loadNext()
  })
}

export function toMulFormData(data) {
  const formData = new FormData()
  Object.keys(data).forEach(key => {
    formData.append(key, data[key])
  })
  return formData
}

/**
 * 返回有变动的属性
 * @param oldVal {Object} 旧的对象
 * @param newVal {Object} 新对象
 * @param filter {Array=} 例外的属性不检测
 * @returns {(boolean|Object)} 变动属性组成的对象，如果属性无变动则返回false
 */
export function getChangeProps(oldVal, newVal, filter = []) {
  if (oldVal === newVal) return {}
  const keys = Object.keys(oldVal)
  const changeProps = {}
  keys.forEach(key => {
    if (filter.includes(key)) return
    if (oldVal[key] !== newVal[key]) {
      changeProps[key] = newVal[key]
    }
  })
  if (!Object.keys(changeProps).length) return false
  return changeProps
}

// 将数据转换为xlsx文件并导出
export function xlsx(json, fields, filename = '.xlsx') { // 导出xlsx
  json.forEach(item => {
    for (const i in item) {
      if (fields.hasOwnProperty(i)) {
        item[fields[i]] = item[i]
      }
      delete item[i] // 删除原先的对象属性
    }
  })
  const sheetName = filename // excel的文件名称
  const wb = XLSX.utils.book_new()  // 工作簿对象包含一SheetNames数组，以及一个表对象映射表名称到表对象。XLSX.utils.book_new实用函数创建一个新的工作簿对象。
  const ws = XLSX.utils.json_to_sheet(json, { header: Object.values(fields) }) // 将JS对象数组转换为工作表。
  wb.SheetNames.push(sheetName)
  wb.Sheets[sheetName] = ws
  const defaultCellStyle = { font: { name: 'Verdana', sz: 13, color: 'FF00FF88' }, fill: { fgColor: { rgb: 'FFFFAA00' }}}// 设置表格的样式
  const wopts = { bookType: 'xlsx', bookSST: false, type: 'binary', cellStyles: true, defaultCellStyle: defaultCellStyle, showGridLines: false }  // 写入的样式
  const wbout = XLSX.write(wb, wopts)
  const blob = new Blob([s2ab(wbout)], { type: 'application/octet-stream' })
  fs.saveAs(blob, filename + '.xlsx')
}

const s2ab = s => {
  var buf
  if (typeof ArrayBuffer !== 'undefined') {
    buf = new ArrayBuffer(s.length)
    var view = new Uint8Array(buf)
    for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xff
    return buf
  } else {
    buf = new Array(s.length)
    for (var i = 0; i != s.length; ++i) buf[i] = s.charCodeAt(i) & 0xFF
    return buf
  }
}

// 限流
export function throttle(fn, interval) {
  let last = 0
  return function() {
    const now = Date.now()
    if (now - last >= interval) {
      last = now
      fn.apply(this, arguments)
    }
  }
}

// 防抖
export function debounce(fn, delay) {
  let timer = null
  return function() {
    if (timer) {
      clearTimeout(timer)
    }
    timer = setTimeout(() => {
      fn.apply(this, arguments)
    }, delay)
  }
}

/**
 * 添加了自动转参数
 * @returns Promise
 */
export function agencyQnbarRequest2() {
  try {
    arguments[1] = humpToUnderline(arguments[1])
  } catch (e) { }
  return agencyQnbarRequest.apply(null, arguments)
}

// 驼峰转下划线
export function humpToUnderline(obj) {
  const newObj = {}
  for (let key in obj) {
    const val = obj[key]
    key = key.replace(/[A-Z]/g, (str) => {
      return '_' + str.toLowerCase()
    })
    newObj[key] = val
  }
  return newObj
}

export function getDateStartTime(date) {
  return new Date(`${parseTime(date, '{y}-{m}-{d}')} 0:0:0`).getTime() / 1000
}

export function getDateEndTime(date) {
  return new Date(`${parseTime(date, '{y}-{m}-{d}')} 23:59:59`).getTime() / 1000
}

/**
 * 获取高德地图构造函数
 */
export const getAMap = (function() {
  window._AMapSecurityConfig = {
    securityJsCode: '79770c81abc0a8d17a37e2263f6633d0'      // 密钥
  }
  const AMap = null
  return () => {
    if (AMap) return Promise.resolve(AMap)
    return AMapLoader.load({
      key: '2291eb77f53217f765e03c6a2c46c064',
      version: '2.0',
      plugins: ['AMap.ControlBar', 'AMap.PlaceSearch', 'AMap.MouseTool', 'AMap.ElasticMarker', 'AMap.HawkEye', 'AMap.DistrictSearch', 'AMap.Autocomplete', 'AMap.Scale', 'AMap.ToolBar', 'AMap.Geocoder', 'AMap.Geolocation']
    }).then(AMap => {
      return AMap
    })
  }
})()

// 获取图片分辨率
export function getImageInfo(url) {
  return new Promise((resolve) => {
    const image = new Image()
    let w, h
    image.src = url
    if (!image.complete) {
      image.onload = function() {
        w = image.width
        h = image.height
        image.onload = null
        resolve({
          width: w,
          height: h
        })
      }
      return
    }
    w = image.width
    h = image.height
    resolve({
      width: w,
      height: h
    })
  })
}

/**
 * 拷贝部分对象
 * @param {Object} obj 拷贝的元数据
 * @param {Array} props 属性名组成的数组
 */
export function pick(obj, props) {
  const data = props.reduce(
    (data, key) => {
      if (key in obj) {
        data[key] = obj[key]
      }
      return data
    }, {}
  )
  return data
}

/**
 * 获取文件相对路径
 * @param {string} fullPath 全路径
 * @returns
 */
export function getRlativePath(fullPath) {
  if (!fullPath) return ''
  return fullPath.replace(/(http(s)?:\/\/)[\w\.]+(\.cn|\.com)/g, '')
}

// 获取日期的当日结束时间，单位（秒）
export function getDateEndTimestamp(date) {
  return date.setHours(23, 59, 59, 0) / 1000
}

// 计算文件的MD5
export function calculateMD5File_2(file, chunkSize) {
  return new Promise((resolve, reject) => {
    const blobSlice = File.prototype.slice || File.prototype.mozSlice || File.prototype.webkitSlice
    const chunks = Math.ceil(file.size / chunkSize)
    let currentChunk = 0
    const spark = new SparkMD5.ArrayBuffer()
    const fileReader = new FileReader()
    fileReader.onload = function(e) {
      spark.append(e.target.result)
      currentChunk++
      if (currentChunk < chunks) {
        loadNext()
      } else {
        const md5 = spark.end()
        resolve(md5)
      }
    }
    fileReader.onerror = function(e) {
      reject(e)
    }
    function loadNext() {
      const start = currentChunk * chunkSize
      let end = start + chunkSize
      if (end > file.size) {
        end = file.size
      }
      fileReader.readAsArrayBuffer(blobSlice.call(file, start, end))
    }
    loadNext()
  })
}

// 获取日期的当日开始时间，单位（秒）
export function getDateStartTimestamp(date) {
  return date.setHours(0, 0, 0, 0) / 1000
}

/**
 * 代理http请求，返回promise对象 (与之前的http请求没有变化，去掉了的默认弹出框错误提示)
 * @param name {string} api名称
 * @param params {object} api参数
 * @returns Promise
 */
export function agencyQnbarRequest_noalert(name, params = {}, mode) {
  return new Promise((resolve, reject) => {
    PT.apiClient.query(svrapi[name], params, (res) => {
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(res)
      }
    }, (err) => {
      reject({ code: -1, msg: '网络请求失败: ' + err })
    }, mode)
  })
}


/**
 * 下载文件，适用于批量下载
 * @param {string} url 下载文件的url
 * @param {number} triggerDelay 延迟添加iframe时间
 * @param {number} removeDelay 延迟删除iframe时间
 */
export function downloadFile(url, triggerDelay = 100, removeDelay = 1000) {
  //动态添加iframe，设置src，然后删除
  // 动态添加iframe，设置src，然后删除
  setTimeout(function () {
    var frame = $('<iframe style="display: none;" class="multi-download"></iframe>');
    frame.attr('src', url);
    $(document.body).after(frame);
    setTimeout(function () {
      frame.remove();
    }, removeDelay);
  }, triggerDelay);
}




// WEBPACK FOOTER //
// ./src/utils/index.js